import { getFullName } from "shared/utils/get-full-name";
import { ApplicationActivity, RepeatApplication } from "../types";

interface ApplicationCanceledProps {
  activityItem: ApplicationActivity;
}

const formatName = (contact?: {
  first_name: string | null;
  middle_name?: string | null;
  last_name: string | null;
}) =>
  contact?.first_name
    ? getFullName({
        firstName: contact.first_name,
        middleName: contact.middle_name ?? undefined,
        lastName: contact.last_name ?? ""
      })
    : null;

const formatUnit = (repeatApplication: RepeatApplication) =>
  [repeatApplication.unit_name, repeatApplication.unit_address]
    .filter(Boolean)
    .join(" at ");

export const ApplicationCanceled = ({
  activityItem
}: ApplicationCanceledProps) => {
  const { auto_canceled, contact, repeat_application } = activityItem.details;

  return (
    <div className="space-y-1">
      <p className="text-base text-content-1000">
        <span className="font-bold">
          Application was {auto_canceled ? "automatically " : ""}
          {activityItem.activity_type}&nbsp;
        </span>
        for {formatName(contact) ?? "everyone in group"}
      </p>
      {repeat_application ? (
        <p className="text-sm font-normal text-content-400">
          {formatName(repeat_application.contact) ?? "An applicant"} submitted
          an application for a different unit: {formatUnit(repeat_application)}
        </p>
      ) : null}
    </div>
  );
};
